export default __webpack_public_path__ + "static/media/title-background.ec6e2680.svg";